import { Component, input } from '@angular/core'

@Component({
  selector: 'app-legend-item',
  templateUrl: './legend-item.component.html',
  standalone: false,
})
export class LegendItemComponent {
  value = input<string | undefined | null>(undefined)
  description = input('')
  type = input<string | undefined>('')
  category = input<string | undefined>('')
}
